module.exports = __webpack_public_path__ + "img/hehuo.8c9cf0a9.png";